(() => {
  const T = window.tema || { rutas: {}, textos: {} };
  const raiz = ((T.rutas && T.rutas.raiz) || '/').replace(/\/?$/, '/');
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const html = (texto) => new DOMParser().parseFromString(texto, 'text/html');

  function formatoDinero(centavos, formato) {
    const fmt = String(formato || T.formatoDinero || '${{amount}}').replace(/<[^>]*>/g, '');
    const patron = /\{\{\s*(\w+)\s*\}\}/;
    const conSeparadores = (n, dec, miles = ',', decimal = '.') => {
      if (n == null || isNaN(n)) return '0';
      const partes = (Number(n) / 100).toFixed(dec).split('.');
      return partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles) + (partes[1] ? decimal + partes[1] : '');
    };
    const m = fmt.match(patron);
    if (!m) return fmt;
    const valores = {
      amount: () => conSeparadores(centavos, 2),
      amount_no_decimals: () => conSeparadores(centavos, 0),
      amount_with_comma_separator: () => conSeparadores(centavos, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => conSeparadores(centavos, 0, '.', ','),
      amount_with_apostrophe_separator: () => conSeparadores(centavos, 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => conSeparadores(centavos, 0, ' ', ''),
      amount_with_space_separator: () => conSeparadores(centavos, 2, ' ', ','),
      amount_with_period_and_space_separator: () => conSeparadores(centavos, 2, ' ', '.')
    };
    return fmt.replace(patron, (valores[m[1]] || valores.amount)());
  }

  function abrirDialogo(dialogo, disparador) {
    if (!dialogo || dialogo.open || !dialogo.showModal) return;
    dialogo._disparador = disparador || document.activeElement;
    dialogo.showModal();
    if (disparador && disparador.hasAttribute('aria-expanded')) disparador.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('close', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDialogElement)) return;
    const disparador = d._disparador;
    if (disparador && disparador.isConnected) {
      if (disparador.hasAttribute('aria-expanded')) disparador.setAttribute('aria-expanded', 'false');
      disparador.focus({ preventScroll: true });
    }
  }, true);

  const Carro = {
    lateral: 'carro-lateral',
    idPagina() { const p = $('[data-carro-pagina]'); return p ? p.dataset.seccion : null; },
    secciones() { return [this.lateral, this.idPagina()].filter(Boolean).join(','); },
    async pedir(ruta, cuerpo, json) {
      const opciones = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: cuerpo };
      if (json) { opciones.headers['Content-Type'] = 'application/json'; opciones.body = JSON.stringify(cuerpo); }
      const r = await fetch(raiz + ruta, opciones);
      const datos = await r.json();
      if (!r.ok || datos.status) throw new Error(datos.description || datos.message || T.textos.errorCarro);
      this.pintar(datos.sections);
      document.dispatchEvent(new CustomEvent('carro:actualizado', { detail: datos }));
      return datos;
    },
    agregar(form) {
      const fd = new FormData(form);
      fd.append('sections', this.secciones());
      fd.append('sections_url', location.pathname);
      return this.pedir('cart/add.js', fd, false);
    },
    cambiar(clave, cantidad) {
      return this.pedir('cart/change.js', { id: clave, quantity: cantidad, sections: this.secciones(), sections_url: location.pathname }, true);
    },
    pintar(secciones) {
      if (!secciones) return;
      if (secciones[this.lateral]) {
        const nuevo = html(secciones[this.lateral]).querySelector('[data-carro-interior]');
        const actual = $('[data-carro-interior]');
        if (nuevo && actual) { actual.replaceWith(nuevo); this.cuenta(nuevo.dataset.cuenta); }
      }
      const id = this.idPagina();
      if (id && secciones[id]) {
        const nuevo = html(secciones[id]).querySelector('[data-carro-pagina]');
        const actual = $('[data-carro-pagina]');
        if (nuevo && actual) actual.replaceWith(nuevo);
      }
    },
    cuenta(n) {
      $$('[data-carro-cuenta]').forEach((b) => { b.textContent = n; b.hidden = Number(n) === 0; });
    },
    abrir() {
      const d = $('#carro-lateral');
      if (d && !d.open) abrirDialogo(d);
    }
  };
  T.carro = Carro;

  async function actualizarLinea(linea, cantidad) {
    if (!linea) return;
    linea.setAttribute('aria-busy', 'true');
    try {
      await Carro.cambiar(linea.dataset.linea, cantidad);
    } catch (err) {
      linea.removeAttribute('aria-busy');
      window.alert(err.message);
    }
  }

  document.addEventListener('click', (e) => {
    const abrir = e.target.closest('[data-abrir]');
    if (abrir) {
      const d = document.getElementById(abrir.dataset.abrir);
      if (d && d.showModal) {
        e.preventDefault();
        abrirDialogo(d, abrir);
        const campo = d.querySelector('input[type="search"]');
        if (campo) setTimeout(() => campo.focus(), 30);
      }
      return;
    }
    const verMas = e.target.closest('[data-ver-mas]');
    if (verMas) {
      const zona = verMas.closest('[data-resultados]') || document;
      const ocultos = $$('li[data-mas][hidden]', zona);
      const paso = Number(verMas.dataset.paso) || 24;
      ocultos.slice(0, paso).forEach((li) => { li.hidden = false; });
      const total = $$('.grilla-productos > li', zona).length;
      const vistos = total - Math.max(0, ocultos.length - paso);
      const n = $('[data-vistos]', zona);
      if (n) n.textContent = vistos;
      const barra = $('[data-vistos-barra]', zona);
      if (barra) barra.style.width = `${(vistos / total) * 100}%`;
      if (ocultos.length <= paso) verMas.hidden = true;
      return;
    }
    const carro = e.target.closest('[data-abrir-carro]');
    if (carro && T.carroTipo === 'drawer' && $('#carro-lateral') && !document.body.classList.contains('plantilla-cart')) {
      e.preventDefault();
      abrirDialogo($('#carro-lateral'), carro);
      return;
    }
    const cerrar = e.target.closest('[data-cerrar]');
    if (cerrar) {
      const d = cerrar.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target instanceof HTMLDialogElement && e.target.open) {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
      return;
    }
    const boton = e.target.closest('[data-linea-cambiar]');
    if (boton) {
      const linea = boton.closest('[data-linea]');
      const input = linea && $('[data-linea-cantidad]', linea);
      if (!input) return;
      const n = Math.max(0, (parseInt(input.value, 10) || 0) + (boton.dataset.lineaCambiar === 'mas' ? 1 : -1));
      actualizarLinea(linea, n);
      return;
    }
    const quitar = e.target.closest('[data-linea-quitar]');
    if (quitar) {
      e.preventDefault();
      actualizarLinea(quitar.closest('[data-linea]'), 0);
    }
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-linea-cantidad]')) {
      actualizarLinea(t.closest('[data-linea]'), Math.max(0, parseInt(t.value, 10) || 0));
    } else if (t.id === 'carro-nota') {
      fetch(raiz + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: t.value }) });
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('[data-formulario-producto], [data-agregar]')) return;
    if (T.carroTipo !== 'drawer' || !$('#carro-lateral')) return;
    e.preventDefault();
    const boton = e.submitter || $('[type="submit"]', form);
    const error = $('[data-error]', form);
    if (boton) { boton.setAttribute('aria-busy', 'true'); boton.disabled = true; }
    try {
      await Carro.agregar(form);
      if (error) error.hidden = true;
      if (!form.hasAttribute('data-no-abrir')) Carro.abrir();
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; } else { window.alert(err.message); }
    } finally {
      if (boton) { boton.removeAttribute('aria-busy'); boton.disabled = false; }
    }
  });

  document.addEventListener('shopify:section:select', (e) => {
    if (e.detail && e.detail.sectionId === 'carro-lateral') Carro.abrir();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.detail && e.detail.sectionId === 'carro-lateral') { const d = $('#carro-lateral'); if (d && d.open) d.close(); }
  });

  const definir = (nombre, clase) => { if (!customElements.get(nombre)) customElements.define(nombre, clase); };

  definir('anuncio-rotativo', class extends HTMLElement {
    connectedCallback() {
      this.mensajes = $$('[data-mensaje]', this);
      if (this.mensajes.length < 2) return;
      this.i = 0;
      this.reloj = setInterval(() => {
        if (this.matches(':hover, :focus-within')) return;
        this.mensajes[this.i].hidden = true;
        this.i = (this.i + 1) % this.mensajes.length;
        this.mensajes[this.i].hidden = false;
      }, 5000);
    }
    disconnectedCallback() { clearInterval(this.reloj); }
  });

  definir('menu-escritorio', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const b = e.target.closest('.menu__abrir');
        if (!b) return;
        const abierto = b.getAttribute('aria-expanded') === 'true';
        this.cerrarTodo();
        b.setAttribute('aria-expanded', String(!abierto));
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const b = $('.menu__abrir[aria-expanded="true"]', this);
        this.cerrarTodo();
        if (b) b.focus();
      });
      this.addEventListener('mouseover', (e) => {
        const item = e.target.closest('.menu__item');
        if (!item) return;
        $$('.menu__abrir[aria-expanded="true"]', this).forEach((b) => { if (!item.contains(b)) b.setAttribute('aria-expanded', 'false'); });
      });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.cerrarTodo(); });
      this._fuera = (e) => { if (!this.contains(e.target)) this.cerrarTodo(); };
      document.addEventListener('click', this._fuera);
    }
    disconnectedCallback() { document.removeEventListener('click', this._fuera); }
    cerrarTodo() { $$('.menu__abrir[aria-expanded="true"]', this).forEach((b) => b.setAttribute('aria-expanded', 'false')); }
  });

  definir('buscador-predictivo', class extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.resultados = $('[data-resultados]', this);
      if (!this.input || !this.resultados) return;
      this.input.addEventListener('input', () => {
        clearTimeout(this.espera);
        this.espera = setTimeout(() => this.buscar(), 250);
      });
      this.input.addEventListener('keydown', (e) => this.teclas(e));
    }
    async buscar() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.resultados.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      if (this.control) this.control.abort();
      this.control = new AbortController();
      const url = `${T.rutas.busquedaPredictiva}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=busqueda-predictiva`;
      try {
        const r = await fetch(url, { signal: this.control.signal });
        if (!r.ok) throw new Error(String(r.status));
        const contenido = html(await r.text()).querySelector('[data-predictiva]');
        this.resultados.innerHTML = contenido ? contenido.outerHTML : '';
        this.input.setAttribute('aria-expanded', contenido ? 'true' : 'false');
        this.activo = -1;
      } catch (err) {
        if (err.name !== 'AbortError') this.resultados.innerHTML = '';
      }
    }
    teclas(e) {
      const opciones = $$('[role="option"]', this.resultados);
      if (!opciones.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.activo = (this.activo == null ? -1 : this.activo) + (e.key === 'ArrowDown' ? 1 : -1);
        if (this.activo < 0) this.activo = opciones.length - 1;
        if (this.activo >= opciones.length) this.activo = 0;
        opciones.forEach((o, i) => o.setAttribute('aria-selected', String(i === this.activo)));
        opciones[this.activo].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.activo >= 0) {
        const a = $('a', opciones[this.activo]);
        if (a) { e.preventDefault(); location.href = a.href; }
      }
    }
  });

  definir('galeria-producto', class extends HTMLElement {
    connectedCallback() {
      this.pista = $('[data-pista]', this);
      this.slides = $$('.galeria__slide', this).filter((s) => !s.hidden);
      this.mins = $$('[data-ir]', this);
      this.contador = $('[data-contador]', this);
      this.actual = 0;
    const tiraMins = $('.galeria__mins', this);
    const flechasMins = $$('[data-mins-mover]', this);
    if (tiraMins && flechasMins.length) {
      const verFlechas = () => { const sobra = tiraMins.scrollWidth > tiraMins.clientWidth + 2; flechasMins.forEach((b) => { b.hidden = !sobra; }); };
      flechasMins.forEach((b) => b.addEventListener('click', () => tiraMins.scrollBy({ left: Number(b.dataset.minsMover) * tiraMins.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' })));
      window.addEventListener('resize', verFlechas);
      verFlechas();
    }
      if (!this.pista || this.slides.length < 2) return;
      const anterior = $('[data-anterior]', this);
      const siguiente = $('[data-siguiente]', this);
      if (anterior) anterior.addEventListener('click', () => this.ir(this.actual - 1));
      if (siguiente) siguiente.addEventListener('click', () => this.ir(this.actual + 1));
      this.mins.forEach((m) => m.addEventListener('click', () => this.ir(Number(m.dataset.ir))));
      this.pista.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => {
          const i = Math.round(this.pista.scrollLeft / this.pista.clientWidth);
          if (i !== this.actual) this.marcar(i);
        });
      }, { passive: true });
      this.pista.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.ir(this.actual + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.ir(this.actual - 1); }
      });
      this._resize = () => { this.pista.scrollLeft = this.actual * this.pista.clientWidth; };
      window.addEventListener('resize', this._resize);
    }
    disconnectedCallback() { window.removeEventListener('resize', this._resize); }
    marcar(i) {
      this.actual = i;
      this.mins.forEach((m) => m.setAttribute('aria-current', Number(m.dataset.ir) === i ? 'true' : 'false'));
    const tira = $('.galeria__mins', this);
    const activa = tira && $(`.galeria__min[data-ir="${i}"]`, tira);
    if (tira && activa && tira.scrollWidth > tira.clientWidth) tira.scrollTo({ left: activa.offsetLeft - (tira.clientWidth - activa.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      if (this.contador) this.contador.textContent = `${i + 1} / ${this.slides.length}`;
      this.slides.forEach((s, k) => { const v = $('video', s); if (v && k !== i) v.pause(); });
    }
    ir(i, suave = true) {
      if (!this.pista || !this.slides.length) return;
      i = (i + this.slides.length) % this.slides.length;
      this.pista.scrollTo({ left: i * this.pista.clientWidth, behavior: suave && !reduce ? 'smooth' : 'auto' });
      this.marcar(i);
    }
    irAMedia(id, suave = true) {
      const k = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (k >= 0 && k !== this.actual) this.ir(k, suave);
    }
    // Fotos por variante: muestra sólo las fotos sin variante y las de la variante elegida
    filtrar(idVariante) {
      const todas = $$('.galeria__slide', this);
      if (!todas.some((s) => s.dataset.deVariantes)) return;
      const clave = `,${idVariante},`;
      const ocultas = new Set();
      todas.forEach((s) => {
        const ver = !s.dataset.deVariantes || s.dataset.deVariantes.includes(clave);
        s.hidden = !ver;
        if (!ver) ocultas.add(s.dataset.mediaId);
      });
      ['.galeria__punto', '.galeria__min'].forEach((sel) => {
        let k = 0;
        $$(sel, this).forEach((b) => {
          const oculta = ocultas.has(b.dataset.mediaId);
          b.hidden = oculta;
          b.dataset.ir = oculta ? -1 : k++;
        });
      });
      this.slides = todas.filter((s) => !s.hidden);
      this.actual = -1;
      this.ir(0, false);
    }
  });

  definir('selector-cantidad', class extends HTMLElement {
    connectedCallback() {
      this.input = $('input', this);
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-menos], [data-mas]');
        if (!b || !this.input) return;
        const min = Number(this.input.min || 1);
        const max = Number(this.input.max || 99);
        let v = parseInt(this.input.value, 10) || min;
        v += b.hasAttribute('data-mas') ? 1 : -1;
        this.input.value = Math.min(max, Math.max(min, v));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  definir('producto-principal', class extends HTMLElement {
    connectedCallback() {
      try { this.variantes = JSON.parse(($('[data-variantes]', this) || {}).textContent || '[]'); } catch (err) { this.variantes = []; }
      this.inputId = $('[data-variante-id]', this);
      this.galeria = $('galeria-producto', this);
      this.addEventListener('change', (e) => {
        if (e.target.matches('selector-variantes input[type="radio"]')) this.alCambiarOpcion();
        else if (e.target.name === 'quantity') this.pintarPrecio();
      });
      const v = this.varianteActual();
      if (v && v.media && this.galeria && this.galeria.irAMedia) requestAnimationFrame(() => this.galeria.irAMedia(v.media, false));
      this.actualizarDisponibilidad();
    }
    seleccion() { return $$('selector-variantes fieldset', this).map((g) => { const i = $('input:checked', g); return i ? i.value : null; }); }
    varianteActual() { const id = Number(this.inputId && this.inputId.value); return this.variantes.find((v) => v.id === id); }
    alCambiarOpcion() {
      const sel = this.seleccion();
      $$('[data-opcion-valor]', this).forEach((s, i) => { s.textContent = sel[i] || ''; });
      const v = this.variantes.find((x) => x.opciones.every((o, i) => o === sel[i]));
      this.aplicar(v);
      this.actualizarDisponibilidad();
    }
    aplicar(v) {
      const botones = $$('[data-boton-agregar], [data-barra-boton]', this);
      if (!v) {
        botones.forEach((b) => { b.disabled = true; b.textContent = T.textos.noDisponible; });
        return;
      }
      this.variante = v;
      if (this.inputId) this.inputId.value = v.id;
      botones.forEach((b) => { b.disabled = !v.disponible; b.textContent = v.disponible ? T.textos.agregar : T.textos.agotado; });
      this.pintarPrecio();
      if (this.galeria && this.galeria.filtrar) this.galeria.filtrar(v.id);
      if (v.media && this.galeria && this.galeria.irAMedia) {
        this.galeria.irAMedia(v.media);
        this.mostrarGaleria();
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url);
    }
    // En celular el selector queda bajo la foto: al cambiar de variante, sube hasta la galería si no se ve
    mostrarGaleria() {
      const r = this.galeria.getBoundingClientRect();
      const cabecera = $('.seccion-cabecera');
      const tope = cabecera ? Math.max(0, cabecera.getBoundingClientRect().bottom) : 0;
      const visible = r.top >= tope - r.height * 0.25 && r.top < window.innerHeight * 0.5;
      if (!visible) window.scrollTo({ top: window.scrollY + r.top - tope - 8, behavior: reduce ? 'auto' : 'smooth' });
    }
    pintarPrecio() {
      const v = this.variante || this.varianteActual();
      if (!v) return;
      const cantidad = $('input[name="quantity"]', this);
      const q = Math.max(1, (cantidad && parseInt(cantidad.value, 10)) || 1);
      const precio = $('[data-precio]', this);
      if (precio) precio.textContent = formatoDinero(v.precio);
      const antes = $('[data-precio-antes]', this);
      if (antes) {
        antes.hidden = !(v.antes > v.precio);
        const monto = $('[data-precio-antes-monto]', antes);
        if (monto) monto.textContent = formatoDinero(v.antes);
      }
      const cuotas = $('[data-cuotas]', this);
      if (cuotas && T.cuotas > 1) cuotas.textContent = T.textos.cuotas.replace('[cuotas]', T.cuotas).replace('[monto]', formatoDinero(Math.round((v.precio * q) / T.cuotas)));
      const barra = $('[data-barra-precio]', this);
      if (barra) barra.textContent = formatoDinero(v.precio * q);
    }
    actualizarDisponibilidad() {
      const grupos = $$('selector-variantes fieldset', this);
      if (!grupos.length) return;
      const sel = this.seleccion();
      grupos.forEach((g, i) => {
        $$('input[type="radio"]', g).forEach((input) => {
          const prueba = sel.slice();
          prueba[i] = input.value;
          const hay = this.variantes.some((v) => v.disponible && v.opciones.every((o, k) => o === prueba[k]));
          if (input.nextElementSibling) input.nextElementSibling.classList.toggle('variante--agotada', !hay);
        });
      });
    }
  });

  definir('barra-compra', class extends HTMLElement {
    connectedCallback() {
      this.cta = document.getElementById(this.dataset.cta);
      this.wsp = $('[data-wsp]');
      this.revisar = this.revisar.bind(this);
      this._scroll = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(this.revisar); };
      window.addEventListener('scroll', this._scroll, { passive: true });
      window.addEventListener('resize', this.revisar);
      window.addEventListener('load', this.revisar);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.revisar);
      this.revisar();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._scroll);
      window.removeEventListener('resize', this.revisar);
      if (this.wsp) { this.wsp.style.transform = ''; this.wsp.classList.remove('wsp--aparte'); }
    }
    revisar() {
      if (!this.cta) return;
      const r = this.cta.getBoundingClientRect();
      const alto = window.innerHeight;
      const mostrar = window.innerWidth < 1000 && (r.bottom < 0 || r.bottom > alto);
      if (this.hidden === mostrar) this.hidden = !mostrar;
      if (!this.wsp) return;
      const sube = mostrar ? this.offsetHeight : 0;
      this.wsp.style.transform = sube ? `translateY(-${sube}px)` : '';
      const abajo = alto - 16 - sube;
      const arriba = abajo - this.wsp.offsetHeight;
      const choca = !mostrar && r.top < abajo && r.bottom > arriba && r.right > window.innerWidth - 16 - this.wsp.offsetWidth;
      this.wsp.classList.toggle('wsp--aparte', choca);
    }
  });

  definir('regla-edad', class extends HTMLElement {
    connectedCallback() {
      this.input = $('[data-regla]', this);
      this.segs = $$('[data-seg]', this);
      this.acciones = $$('[data-etapa]', this);
      this.resultado = $('[data-resultado]', this);
      if (!this.input || !this.acciones.length) return;
      this.input.addEventListener('input', () => this.pintar());
      this.pintar();
    }
    edad(m, max) {
      if (m === 0) return T.textos.recienNacido;
      if (m >= max) return `${max} ${T.textos.meses} ${T.textos.masDe}`;
      return `${m} ${m === 1 ? T.textos.mesUno : T.textos.meses}`;
    }
    pintar() {
      const m = parseInt(this.input.value, 10) || 0;
      const max = Number(this.dataset.maximo || this.input.max);
      const activa = this.acciones.find((a) => m >= Number(a.dataset.desde) && m < Number(a.dataset.hasta))
        || this.acciones.slice().reverse().find((a) => m >= Number(a.dataset.desde))
        || this.acciones[0];
      const texto = this.edad(m, max);
      this.input.setAttribute('aria-valuetext', texto);
      this.acciones.forEach((a) => { a.hidden = a !== activa; });
      this.segs.forEach((s) => {
        const es = s.dataset.seg === activa.dataset.etapa;
        s.classList.toggle('es', es);
        s.textContent = es ? s.dataset.larga : s.dataset.corta;
      });
      if (this.resultado) {
        const etiqueta = activa.dataset.etiqueta || '';
        const plantilla = m === 0 && this.dataset.textoCero ? this.dataset.textoCero : this.dataset.texto || '';
        this.resultado.textContent = plantilla.replace('[edad]', texto.toLowerCase()).replace('[etapa]', etiqueta);
      }
    }
  });

  definir('recomendaciones-producto', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || !('IntersectionObserver' in window)) return;
      this.observador = new IntersectionObserver((entradas) => {
        if (!entradas[0].isIntersecting) return;
        this.observador.disconnect();
        this.cargar();
      }, { rootMargin: '0px 0px 400px 0px' });
      this.observador.observe(this);
    }
    disconnectedCallback() { if (this.observador) this.observador.disconnect(); }
    async traer(url) {
      const r = await fetch(url);
      if (!r.ok) return null;
      return html(await r.text()).querySelector('[data-recomendaciones]');
    }
    async cargar() {
      try {
        let bloque = await this.traer(this.dataset.url);
        if ((!bloque || Number(bloque.dataset.cantidad) === 0) && this.dataset.urlAlterna) {
          const alterna = await this.traer(this.dataset.urlAlterna);
          if (alterna && Number(alterna.dataset.cantidad) > 0) bloque = alterna;
        }
        if (bloque) this.innerHTML = bloque.outerHTML;
      } catch (err) {
        this.innerHTML = '';
      }
    }
  });

  definir('filtros-coleccion', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        if (!e.target.closest('[data-form-filtros]') && !e.target.matches('[data-orden]')) return;
        clearTimeout(this.espera);
        this.espera = setTimeout(() => this.aplicar(), e.target.type === 'number' ? 700 : 60);
      });
      this.addEventListener('submit', (e) => {
        if (!e.target.matches('[data-form-filtros]')) return;
        e.preventDefault();
        this.aplicar();
      });
      this.addEventListener('click', (e) => {
        const quitar = e.target.closest('[data-quitar-filtro]');
        if (quitar) { e.preventDefault(); this.cargar(quitar.href); return; }
        const pagina = e.target.closest('.paginacion a');
        if (pagina) { e.preventDefault(); this.cargar(pagina.href, true); return; }
        if (e.target.closest('[data-abrir-filtros]')) { this.abrir(); return; }
        if (e.target.closest('[data-cerrar-filtros]')) this.cerrar();
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.cerrar(); });
      this._pop = () => { if (history.state && history.state.filtros !== undefined) this.cargar(location.href, false, false); };
      window.addEventListener('popstate', this._pop);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this._pop); document.documentElement.style.overflow = ''; }
    abrir() {
      const panel = $('[data-panel-filtros]', this);
      if (!panel) return;
      panel.classList.add('filtros-panel--abierto');
      document.documentElement.style.overflow = 'hidden';
      const b = $('[data-abrir-filtros]', this);
      if (b) b.setAttribute('aria-expanded', 'true');
      const cerrar = $('[data-cerrar-filtros]', panel);
      if (cerrar) cerrar.focus();
    }
    cerrar() {
      const panel = $('[data-panel-filtros]', this);
      if (!panel || !panel.classList.contains('filtros-panel--abierto')) return;
      panel.classList.remove('filtros-panel--abierto');
      document.documentElement.style.overflow = '';
      const b = $('[data-abrir-filtros]', this);
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    }
    aplicar() {
      const form = $('[data-form-filtros]', this);
      const orden = $('[data-orden]', this);
      const params = new URLSearchParams();
      if (form) {
        for (const [k, v] of new FormData(form)) { if (v !== '') params.append(k, v); }
      }
      if (orden && !params.has('sort_by')) params.set('sort_by', orden.value);
      this.cargar(`${location.pathname}?${params.toString()}`);
    }
    async cargar(url, subir = false, empujar = true) {
      const destino = new URL(url, location.origin);
      const pedido = new URL(destino.href);
      pedido.searchParams.set('section_id', this.dataset.seccion);
      const resultados = $('[data-resultados]', this);
      if (resultados) resultados.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(pedido.href);
        if (!r.ok) throw new Error(String(r.status));
        const doc = html(await r.text());
        ['[data-cuenta]', '[data-activos]', '[data-resultados]', '[data-ver-n]', '[data-filtrar-n]'].forEach((sel) => {
          const nuevo = doc.querySelector(sel);
          const actual = $(sel, this);
          if (nuevo && actual) actual.replaceWith(nuevo);
        });
        const nuevoForm = doc.querySelector('[data-form-filtros]');
        const actualForm = $('[data-form-filtros]', this);
        if (nuevoForm && actualForm) {
          const estado = new Map($$('details', actualForm).map((d) => [($('summary', d) || {}).textContent, d.open]));
          $$('details', nuevoForm).forEach((d) => {
            const clave = ($('summary', d) || {}).textContent;
            if (estado.has(clave)) d.open = estado.get(clave);
          });
          actualForm.replaceWith(nuevoForm);
        }
        if (empujar) history.pushState({ filtros: true }, '', destino.pathname + destino.search);
        if (subir) this.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      } catch (err) {
        location.href = destino.href;
      } finally {
        const res = $('[data-resultados]', this);
        if (res) res.removeAttribute('aria-busy');
      }
    }
  });

  definir('temporizador-despacho', class extends HTMLElement {
    connectedCallback() {
      this.texto = $('[data-texto]', this);
      this.festivos = (this.dataset.festivos || '').split(',').map((s) => s.trim()).filter(Boolean);
      this.modo = '';
      this.tick();
      this.reloj = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.reloj); }
    ahora() {
      const partes = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const p = Object.fromEntries(partes.map((x) => [x.type, x.value]));
      const y = Number(p.year), m = Number(p.month), d = Number(p.day);
      return { y, m, d, fecha: `${p.year}-${p.month}-${p.day}`, dia: new Date(Date.UTC(y, m - 1, d)).getUTCDay(), segundos: Number(p.hour) * 3600 + Number(p.minute) * 60 + Number(p.second) };
    }
    corte(dia) {
      const valor = (dia === 0 ? this.dataset.corteDomingo : this.dataset.corteSemana) || '';
      const [h, mi] = valor.split(':').map(Number);
      return Number.isFinite(h) ? h * 3600 + (Number.isFinite(mi) ? mi : 0) * 60 : null;
    }
    pintar(modo, plantilla, marca, valor) {
      if (!this.texto) return;
      if (this.modo === modo && this.fuerte) { this.fuerte.textContent = valor; return; }
      this.modo = modo;
      const [antes, despues = ''] = plantilla.split(marca);
      this.fuerte = document.createElement('strong');
      this.fuerte.textContent = valor;
      this.texto.replaceChildren(document.createTextNode(antes), this.fuerte, document.createTextNode(despues));
      this.hidden = false;
    }
    tick() {
      const a = this.ahora();
      const corteHoy = this.corte(a.dia);
      if (corteHoy !== null && !this.festivos.includes(a.fecha) && a.segundos < corteHoy) {
        const r = corteHoy - a.segundos;
        const tiempo = [Math.floor(r / 3600), Math.floor((r % 3600) / 60), r % 60].map((n) => String(n).padStart(2, '0')).join(':');
        this.pintar('hoy', this.dataset.textoHoy || '', '[tiempo]', tiempo);
        return;
      }
      let k = 1;
      let fecha = new Date(Date.UTC(a.y, a.m - 1, a.d + 1));
      for (; k <= 14; k++) {
        fecha = new Date(Date.UTC(a.y, a.m - 1, a.d + k));
        if (!this.festivos.includes(fecha.toISOString().slice(0, 10)) && this.corte(fecha.getUTCDay()) !== null) break;
      }
      if (k === 1) {
        this.pintar('manana', this.dataset.textoManana || '', '\u0000', '');
      } else {
        const dia = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { weekday: 'long', timeZone: 'UTC' }).format(fecha);
        this.pintar('otro', this.dataset.textoOtroDia || '', '[dia]', dia);
      }
    }
  });

  const cacheCruzado = new Map();
  definir('carro-cruzado', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.producto && this.dataset.url) this.cargar();
    }
    traer(intent) {
      const clave = `${this.dataset.producto}|${intent}|${this.dataset.carro || ''}`;
      if (!cacheCruzado.has(clave)) {
        const url = `${this.dataset.url}?product_id=${encodeURIComponent(this.dataset.producto)}&limit=8&intent=${intent}&section_id=carro-cruzado`;
        cacheCruzado.set(clave, fetch(url).then((r) => (r.ok ? r.text() : '')).catch(() => ''));
      }
      return cacheCruzado.get(clave).then((texto) => (texto ? html(texto).querySelector('[data-cruzado-resultados]') : null));
    }
    async cargar() {
      let lista = await this.traer('complementary');
      if (!lista || !lista.querySelector('li')) lista = await this.traer('related');
      const actual = $('[data-cruzado-resultados]', this);
      if (this.isConnected && actual && lista && lista.querySelector('li')) actual.replaceWith(lista);
    }
  });

  definir('carrusel-desliza', class extends HTMLElement {
    connectedCallback() {
      this.pista = $('[data-pista]', this);
      this.anterior = $('[data-anterior]', this);
      this.siguiente = $('[data-siguiente]', this);
      if (!this.pista) return;
      const mover = (dir) => this.pista.scrollBy({ left: dir * this.pista.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      if (this.anterior) this.anterior.addEventListener('click', () => mover(-1));
      if (this.siguiente) this.siguiente.addEventListener('click', () => mover(1));
      this._actualizar = () => {
        const max = this.pista.scrollWidth - this.pista.clientWidth - 2;
        if (this.anterior) this.anterior.disabled = this.pista.scrollLeft <= 2;
        if (this.siguiente) this.siguiente.disabled = this.pista.scrollLeft >= max;
      };
      this.pista.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(this._actualizar); }, { passive: true });
      window.addEventListener('resize', this._actualizar);
      this._actualizar();
    }
    disconnectedCallback() { window.removeEventListener('resize', this._actualizar); }
  });

  let videoConSonido = null;
  definir('video-comunidad', class extends HTMLElement {
    connectedCallback() {
      this.video = $('video', this);
      this.boton = $('[data-sonido]', this);
      if (!this.video) return;
      this.video.muted = true;
      if (!reduce && 'IntersectionObserver' in window) {
        this.observador = new IntersectionObserver(([entrada]) => {
          if (entrada.isIntersecting) this.video.play().catch(() => {});
          else { this.video.pause(); if (videoConSonido === this) this.silenciar(); }
        }, { threshold: 0.5 });
        this.observador.observe(this);
      }
      if (this.boton) this.boton.addEventListener('click', () => {
        if (this.video.muted || this.video.paused) this.activar();
        else this.silenciar();
      });
    }
    disconnectedCallback() { if (this.observador) this.observador.disconnect(); if (videoConSonido === this) videoConSonido = null; }
    activar() {
      if (videoConSonido && videoConSonido !== this) videoConSonido.silenciar();
      videoConSonido = this;
      this.video.muted = false;
      this.video.play().catch(() => {});
      this.pintar(true);
    }
    silenciar() {
      this.video.muted = true;
      if (reduce) this.video.pause();
      if (videoConSonido === this) videoConSonido = null;
      this.pintar(false);
    }
    pintar(conSonido) {
      if (!this.boton) return;
      this.boton.setAttribute('aria-pressed', String(conSonido));
      this.boton.setAttribute('aria-label', conSonido ? this.boton.dataset.silenciar : this.boton.dataset.activar);
    }
  });

  if (!history.state) history.replaceState({ filtros: false }, '');
})();
